import { render, staticRenderFns } from "./QuestMenuStandalone.vue?vue&type=template&id=003d38f9&scoped=true"
import script from "./QuestMenuStandalone.vue?vue&type=script&lang=js"
export * from "./QuestMenuStandalone.vue?vue&type=script&lang=js"
import style0 from "./QuestMenuStandalone.vue?vue&type=style&index=0&id=003d38f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d38f9",
  null
  
)

export default component.exports